import pipe from "@insightfulscience/shared-utils/fn/pipe";

const decycle = (obj, stack = []) => {
	if (!obj || typeof obj !== "object") return obj;

	if (stack.includes(obj)) return null;

	const s = stack.concat([obj]);

	return Array.isArray(obj)
		? obj.map(x => decycle(x, s))
		: Object.fromEntries(Object.entries(obj).map(([k, v]) => [k, decycle(v, s)]));
};

const nullTypes = type => object => {
	if (object === null) return object;

	const newObject = Array.isArray(object) ? [...object] : { ...object };

	if (["series", "guides"].includes(type)) {
		if ("recommendedVideos" in newObject) {
			newObject.recommendedVideos = newObject.recommendedVideos.map(rv => ({
				...rv,
				fields: {
					...rv.fields,
					recommendedVideos: null,
				},
			}));
		}
	}

	return newObject;
};

export const sanitize = (object, type = null) => pipe(object, nullTypes(type), decycle);
